<template>
  <error-content code="404" desc="抱歉，您访问的页面不存在" :comp="Svg404"></error-content>
</template>

<script>
import ErrorContent from '@comp/Error/ErrorContent.vue'
import Svg404 from '@comp/Error/Svg404.vue'
export default {
  name: 'error-404',
  components: {
    ErrorContent
  },
  data () {
    return {
      Svg404
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
